import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils/cn";

const Container: FC<ComponentProps<"div">> = ({ className, ...props }) => {
  return (
    <div
      {...props}
      className={cn("relative flex flex-col px-4 md:px-6", className)}
    >
      {props.children}
    </div>
  );
};

export default Container;
